import type { Bonus, PreviewPage, Volume } from '../types/content';
export const volumes: Volume[] = [{
  label: 'VOLUMEN 01',
  title: 'MANUAL DE MOVIMIENTO PARA AFLOJAR TENSIONES',
  subtitle: 'AFLOJÁ TU CUERPO',
  items: ['Recibís 18 secuencias ilustradas de movimiento suave.', 'Tenés movimientos preparados para hombros, cuello, brazos y tronco.', 'Seguís pasos concretos para acompañar la tensión y rigidez cotidiana.'],
  result: '“Sé qué movimientos hacer cuando siento el cuerpo tenso y necesito aflojar.”',
  accent: 'info'
}, {
  label: 'VOLUMEN 02',
  title: 'PROGRAMA DE EXPRESIÓN CORPORAL DE 21 DÍAS',
  subtitle: 'MOVETE A TU RITMO',
  items: ['Recibís un programa de 21 días con una práctica preparada para cada jornada.', 'Seguís tres etapas: Aflojar, Expresar y Reconectar.', 'Tenés tiempos, ilustraciones, calendario y planes para continuar después del programa.'],
  result: '“Tengo mi práctica de cada día organizada, sin preguntarme qué hacer.”',
  accent: 'primary'
}, {
  label: 'VOLUMEN 03',
  title: 'PROTOCOLOS DE MOVIMIENTO PARA DÍAS DIFÍCILES',
  subtitle: 'ACOMPAÑÁ TUS EMOCIONES',
  items: ['Accedés a 12 protocolos corporales para situaciones cotidianas específicas.', 'Encontrás movimientos para momentos de preocupación, frustración, nervios o agotamiento.', 'Seguís una secuencia preparada según el momento que estés atravesando.'],
  result: '“Tengo una práctica concreta para acompañarme cuando atravieso un día difícil.”',
  accent: 'highlight'
}];
export const previewPages: PreviewPage[] = [{
  src: 'https://cdn.magicpatterns.com/uploads/1pNVCbTn6zamQ2FnDdieA1/H1.webp',
  alt: 'Página del kit: Movete sin exigirte, recomendaciones antes de practicar.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/fJBkPuVcSFLWFh8AfkvsrF/H2.webp',
  alt: 'Página del kit: Movimiento base 01, sentí tus apoyos.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rsWhiPvqhkzkQfU2o3hi3E/H3.webp',
  alt: 'Página del kit: Secuencia 03, brazos y manos.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/pDj8NLBJJG6ptnc3XMCEfj/H4.webp',
  alt: 'Página del kit: Secuencia 08, movilidad suave de caderas.'
}];
export const bonuses: Bonus[] = [{
  number: '01',
  title: 'PAUSAS CORPORALES DE 3 MINUTOS',
  items: ['Tenés 12 prácticas breves listas para usar.', 'Incorporás movimientos conscientes entre tus actividades.', 'Podés dedicarte unos minutos sin reorganizar todo tu día.'],
  value: '$12.000'
}, {
  number: '02',
  title: 'MOVIMIENTO CONSCIENTE EN SILLA',
  items: ['Recibís 12 secuencias ilustradas para practicar sentada.', 'Seguís movimientos suaves sin necesidad de ponerte de pie.', 'Tenés una alternativa cómoda para los días en que preferís moverte menos.'],
  value: '$10.000'
}, {
  number: '03',
  title: 'MOVIMIENTO CONSCIENTE EN ESPACIOS REDUCIDOS',
  items: ['Tenés 12 prácticas preparadas para lugares pequeños.', 'Realizás movimientos sin desplazamientos amplios.', 'Podés practicar en casa sin necesitar una habitación especial.'],
  value: '$9.000'
}, {
  number: '04',
  title: 'RUTINAS CORPORALES PARA CERRAR EL DÍA',
  items: ['Recibís 12 rutinas de movimiento lento.', 'Seguís secuencias suaves para acompañar el final de la jornada.', 'Tenés una forma sencilla de bajar el ritmo antes de descansar.'],
  value: '$11.000'
}, {
  number: '05',
  title: 'ACTIVACIÓN CORPORAL SUAVE POR LA MAÑANA',
  items: ['Accedés a 12 prácticas progresivas para comenzar el día.', 'Seguís movimientos sencillos para despertar el cuerpo gradualmente.', 'Tenés una rutina preparada para dedicarte unos minutos desde la mañana.'],
  value: '$10.000'
}];
